// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import MenuPage2 from './pages/MenuPage2';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import EmployeeLoginPage from './pages/EmployeeLoginPage';
import EmployeeDashboardPage from './pages/EmployeeDashboardPage';
import ProtectedRoute from './components/ProtectedRoute';

// Toast servisini içe aktarın - sadece içe aktarmak yeterli, 
// servis kendini otomatik olarak başlatacaktır
import './services/toast.service';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/menu" element={<MenuPage2 />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/employee/login" element={<EmployeeLoginPage />} />
        
        {/* Protected admin routes */}
        <Route element={<ProtectedRoute requiredRole="admin" authType="user" />}>
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          {/* No need for separate routes for menu-management, gallery, etc. 
               since they're handled within the AdminDashboardPage */}
        </Route>
        
        {/* Protected employee routes */}
        <Route element={<ProtectedRoute requiredRole="employee" authType="employee" />}>
          <Route path="/employee/dashboard" element={<EmployeeDashboardPage />} />
          {/* Add more employee-specific routes as needed */}
        </Route>
        
        {/* Redirects */}
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/employee" element={<Navigate to="/employee/login" replace />} />
        
        {/* Fallback: redirect unknown to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
      {/* Toast Container otomatik olarak DOM'a ekleneceği için burada 
          herhangi bir şey render etmemize gerek yok */}
    </Router>
  );
}

export default App;